import React from 'react';
import { Route, RoutePath, RoutesPaths, RoutesProvider, Switch, useRouterHelper } from '@shared/core';
import { ServiceCenter } from '@apps/serviceCenter/ServiceCenter';
import { Messages } from '@apps/serviceCenter/routes/Messages';
import { Events } from './routes/Events';

type RoutesNames = 'servicecenter' | 'messages' | 'eventSafetyRating'; //other subroutes here

export const routePaths: RoutesPaths<RoutesNames> = {
  servicecenter: {
    path: '',
    goToPath: () => ``
  },
  messages: {
    path: 'messages',
    goToPath: () => 'messages'
  },
  eventSafetyRating: {
    path: 'event-safety-rating',
    goToPath: () => 'event-safety-rating'
  }
};

const RoutesServiceCenter = () => {
  const routeHelpers = useRouterHelper();
  const routes: Array<RoutePath<{}>> = [
    { path: routeHelpers.buildPath(routePaths.messages.path), component: () => <Messages /> },
    { path: routeHelpers.buildPath(routePaths.eventSafetyRating.path), component: () => <Events /> }
  ];

  return (
    <Switch>
      <Route exact path={routeHelpers.buildPath(routePaths.servicecenter.path)} render={() => <ServiceCenter />} />
      {routes.map(route => {
        return <Route exact key={route.path} path={route.path} render={route.component} />;
      })}
    </Switch>
  );
};

export const RouterServiceCenter: React.FC<{ appUrl: string }> = ({ appUrl }) => {
  return (
    <RoutesProvider appUrl={appUrl}>
      <RoutesServiceCenter />
    </RoutesProvider>
  );
};
